import '@uirouter/angularjs';
import angular from 'angular';
import 'angular-sanitize';
import 'ui-select';
import 'ui-select/dist/select.css';

import { select } from './select.component';
import './select.sass';

angular.module('tct.select', ['ui.select', 'ngSanitize'])
  .component('tctSelect', select);
